<template>
  <div class="card shadow-sm mt-4">
    <!-- Collapsible Header -->
    <div
      class="card-header bg-white d-flex justify-content-between align-items-center py-3 cursor-pointer"
      style="cursor: pointer"
      @click="isOpen = !isOpen"
    >
      <h6 class="m-0 font-weight-bold text-primary">
        Projects opened and closed by department over selected period
      </h6>
      <button
        type="button"
        class="btn btn-sm btn-link text-decoration-none p-0"
      >
        <i
          class="fas"
          :class="isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"
        ></i>
      </button>
    </div>

    <!-- Collapsible Body -->
    <div v-show="isOpen" class="card-body">
      <!-- Date Filters Controls -->
      <div class="row align-items-end mb-4">
        <div class="col-md-4 col-sm-6 mb-2 mb-md-0">
          <label class="small text-muted font-weight-bold mb-1">From</label>
          <input
            v-model="filters.dateFrom"
            type="date"
            class="form-control form-control-sm"
          />
        </div>
        <div class="col-md-4 col-sm-6 mb-2 mb-md-0">
          <label class="small text-muted font-weight-bold mb-1">To</label>
          <input
            v-model="filters.dateTo"
            type="date"
            class="form-control form-control-sm"
          />
        </div>
        <div class="col-md-4 col-sm-12">
          <button
            type="button"
            class="btn btn-primary btn-sm btn-block"
            :disabled="loading"
            @click="fetchFilteredKpis"
          >
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm mr-1"
            ></span>
            Show results
          </button>
        </div>
      </div>

      <!-- Charts Display Section -->
      <div v-if="loading" class="text-center py-4">
        <div
          class="spinner-border spinner-border-sm text-primary"
          role="status"
        ></div>
      </div>

      <div v-else class="row">
        <chart-card
          v-if="assignedChartData.length"
          :value="assignedChartData"
          label="Projects Assigned"
          size="col-lg-6 col-md-12"
        ></chart-card>

        <chart-card
          v-if="closedChartData.length"
          :value="closedChartData"
          label="Projects Closed"
          size="col-lg-6 col-md-12"
        ></chart-card>
      </div>
    </div>
  </div>
</template>

<script>
import ChartCard from "@/components/ui/ChartCard.vue";
import { getProjectDashboardKpis } from "@/apis/kpis";

export default {
  name: "ProjectsPeriodReportCard",
  components: {
    ChartCard,
  },
  data() {
    return {
      isOpen: false,
      loading: false,
      periodKpis: null,
      filters: {
        dateFrom: "",
        dateTo: "",
      },
    };
  },
  computed: {
    assignedChartData() {
      return this.formatGroupData(this.periodKpis?.projectsAssigned);
    },
    closedChartData() {
      return this.formatGroupData(this.periodKpis?.projectsClosed);
    },
  },
  methods: {
    fieldNameMapper(key) {
      const fieldnames = {
        totalProjects: "TOTAL",
        departmentDna: "D&NA",
        departmentSscs: "SS&CS",
        departmentNsm: "NSM",
        departmentOt: "OT",
        departmentMess: "ME&SS",
        departmentRdi: "RD&I",
        departmentConsultancy: "Consultancy",
        departmentAdministration: "Administration",
      };
      return fieldnames[key] || key;
    },

    formatGroupData(groupObject) {
      if (!groupObject) return [];

      return Object.keys(groupObject).reduce((accumulator, key) => {
        if (key === "total") return accumulator;

        return [
          ...accumulator,
          {
            type: this.fieldNameMapper(key),
            number: groupObject[key] || 0,
          },
        ];
      }, []);
    },

    async fetchFilteredKpis() {
      this.loading = true;
      try {
        const queryParams = {
          dateFrom: this.filters.dateFrom || null,
          dateTo: this.filters.dateTo || null,
        };

        if (!queryParams.dateFrom) delete queryParams.dateFrom;
        if (!queryParams.dateTo) delete queryParams.dateTo;

        const response = await getProjectDashboardKpis(queryParams);
        this.periodKpis = response?.data;
      } catch (error) {
        console.error("Failed to fetch period project KPIs:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
